import { useGetAllSenderPersonas } from "@/lib/api/engageApi";
import { DropdownSearchCombobox } from "./DropdownSearchCombobox";

interface DropdownSenderPersonaSearchProps {
  value?: string;
  placeholder?: string;
  agentType?: string;
  onChange: (value: string) => void;
}

const DropdownSenderPersonaSearch = ({
  value,
  placeholder,
  agentType,
  onChange,
}: DropdownSenderPersonaSearchProps) => {
  const { data, isLoading } = useGetAllSenderPersonas(
    agentType ? { agentType } : undefined,
    {
      request: {
        headers: {
          isPaginated: false,
        },
      },
    }
  );
  
  return (
    <DropdownSearchCombobox
      options={
        data?.data?.map((item: any) => ({
          label: item.name,
          value: item.id?.toString(),
        })) || []
      }
      value={value}
      placeholder={
        !agentType 
          ? "Select agent type first"
          : isLoading 
            ? "Loading sender personas..."
            : placeholder
      }
      disabled={!agentType || isLoading}
      onChange={(value) => onChange(value)}
    />
  );
};

export default DropdownSenderPersonaSearch;
